var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('v-card',{staticClass:"mx-auto px-5 py-2 my-5",attrs:{"max-width":"480px","justify":"center","align":"center","flat":""}},[_c('h2',[_vm._v("About")]),_c('v-card-subtitle',[_vm._v("Under Development")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }